/**
 * @generated SignedSource<<c5dd9b3d6e7e8efd9138cf57974b1571>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WithWalletConnectionEnsuredModalBase_viewer$data = {
  readonly walletConnectFeatureFlag: boolean | null;
  readonly " $fragmentType": "WithWalletConnectionEnsuredModalBase_viewer";
};
export type WithWalletConnectionEnsuredModalBase_viewer$key = {
  readonly " $data"?: WithWalletConnectionEnsuredModalBase_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsuredModalBase_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WithWalletConnectionEnsuredModalBase_viewer",
  "selections": [
    {
      "alias": "walletConnectFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "allowWalletConnect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a5a6b345a509d7364612270f6b42e64f";

export default node;
